import axios from 'axios';
import { LoginCredentials, AuthResponse } from '../types/auth';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const authAxios = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authAPI = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await authAxios.post('/auth/login', credentials);
    return response.data;
  },

  loginWithMicrosoft: async (entraAccessToken: string): Promise<AuthResponse> => {
    const response = await authAxios.post('/auth/microsoft', null, {
      headers: { Authorization: `Bearer ${entraAccessToken}` },
    });
    return response.data;
  },
};